import { createUniqueId } from 'solid-js'

export function AllowListIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `allow-list-icon-${id}-paint0`
  const paint1 = `allow-list-icon-${id}-paint1`
  const clip0 = `allow-list-icon-${id}-clip0`
  const clip1 = `allow-list-icon-${id}-clip1`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <g clip-path={`url(#${clip1})`}>
          <path
            d="M37.3473 26.9674C37.3473 35.0174 30.8173 41.5574 22.7673 41.5574C15.2473 41.5574 9.06731 35.8774 8.26731 28.5774C8.25731 28.5374 8.24731 28.4974 8.24731 28.4574C7.51731 23.9274 8.57731 16.6174 9.38731 12.1674C9.75731 10.1874 11.9173 9.12744 13.7073 10.0574C14.2473 10.3474 14.8173 10.6474 15.4273 10.9774C16.6273 9.14744 17.8373 7.44744 18.9073 5.96744C20.8073 3.34744 24.7173 3.34744 26.6073 5.96744C30.9373 11.9074 37.3373 21.6174 37.3373 26.9674H37.3473Z"
            fill={`url(#${paint0})`}
          />
          <path
            d="M33.2173 26.7175C33.2173 32.5375 28.4973 37.2575 22.6773 37.2575C16.8573 37.2575 12.1373 32.5375 12.1373 26.7175C12.1373 23.5275 15.3073 18.1775 18.1673 13.9875C20.3373 10.8075 25.0273 10.8075 27.1973 13.9875C30.0573 18.1775 33.2273 23.5275 33.2273 26.7175H33.2173Z"
            fill={`url(#${paint1})`}
          />
          <path
            d="M22.6673 30.8475C21.8673 30.8475 21.2073 30.1975 21.2073 29.3875V27.4575H19.2773C18.4773 27.4575 17.8173 26.8075 17.8173 25.9975C17.8173 25.1875 18.4673 24.5375 19.2773 24.5375H21.2073V22.6075C21.2073 21.8075 21.8573 21.1475 22.6673 21.1475C23.4773 21.1475 24.1273 21.7975 24.1273 22.6075V24.5375H26.0573C26.8573 24.5375 27.5173 25.1875 27.5173 25.9975C27.5173 26.8075 26.8673 27.4575 26.0573 27.4575H24.1273V29.3875C24.1273 30.1875 23.4773 30.8475 22.6673 30.8475Z"
            fill="#73FF00"
          />
        </g>
        <path
          d="M40.9559 32.4902L41.6618 31.7843C43.4461 30 43.4461 27.1078 41.6618 25.3333C40.799 24.4706 39.652 24 38.4363 24C37.2206 24 36.0735 24.4706 35.2108 25.3333L34.5049 26.0392L33.799 25.3333C32.9363 24.4706 31.7892 24 30.5735 24C29.3578 24 28.201 24.4608 27.3382 25.3235C25.5637 27.1078 25.5637 30 27.3382 31.7843L28.0441 32.4902L27.3382 33.1961C25.5539 34.9804 25.5539 37.8726 27.3382 39.6471C28.201 40.5098 29.348 40.9804 30.5637 40.9804C31.7794 40.9804 32.9265 40.5098 33.7892 39.6471L34.4951 38.9412L35.201 39.6471C36.0637 40.5098 37.2108 40.9804 38.4265 40.9804C39.6422 40.9804 40.7892 40.5098 41.652 39.6471C43.4363 37.8627 43.4363 34.9706 41.652 33.1961L40.9461 32.4902H40.9559Z"
          fill="white"
        />
        <path
          d="M37.4362 32.4903L39.9068 30.0197C40.7206 29.206 40.7206 27.8922 39.9068 27.0883C39.0931 26.2844 37.7794 26.2746 36.9755 27.0883L34.5049 29.5589L32.0343 27.0883C31.2206 26.2746 29.9068 26.2746 29.1029 27.0883C28.299 27.902 28.2892 29.2158 29.1029 30.0197L31.5735 32.4903L29.1029 34.9609C28.2892 35.7746 28.2892 37.0883 29.1029 37.8922C29.5049 38.2942 30.0343 38.5001 30.5735 38.5001C31.1127 38.5001 31.6323 38.2942 32.0441 37.8922L34.5147 35.4217L36.9853 37.8922C37.3872 38.2942 37.9166 38.5001 38.4558 38.5001C38.9951 38.5001 39.5147 38.2942 39.9264 37.8922C40.7402 37.0785 40.7402 35.7648 39.9264 34.9609L37.4558 32.4903H37.4362Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="16.1773"
          y1="43.4574"
          x2="27.5173"
          y2="7.49744"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FF00" />
          <stop offset="1" stop-color="#99FF00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="20.9973"
          y1="40.2375"
          x2="24.9873"
          y2="8.31754"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#006800" />
          <stop offset="1" stop-color="#00D400" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
        <clipPath id={clip1}>
          <rect
            width="29.35"
            height="37.56"
            fill="white"
            transform="translate(7.99731 3.99756)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
